import * as uuid from 'uuid';
import { get } from 'lodash';
const getGreatestCommonDivisor = function (a, b) {
    if (b === 0) {
        return a;
    }
    return getGreatestCommonDivisor(b, a % b);
};
export const isMenu = (productCatalog, productId) => {
    const product = productCatalog.getProduct(productId, true);
    return isMenuByProduct(product);
};
export const isMenuByProduct = (product) => {
    const mainGroup = product.groups.find((g) => g.appearance === 'single');
    const subProduct = mainGroup ? mainGroup.products[0] : null;
    return mainGroup !== undefined && subProduct !== null;
};
export const DateUtils = {
    addDays(date, days) {
        return new Date(date.getFullYear(), date.getMonth(), date.getDate() + days, date.getHours(), date.getMinutes(), date.getSeconds());
    },
};
export const formatPriceCents = function (priceCents) {
    return formatPrice(priceCents / 100);
};
export const formatIntPrice = (price) => {
    return formatPrice(price, 2, ',-');
};
export const getFormatPriceFunctionForTenant = (tenantId) => {
    if ([6].includes(tenantId)) {
        return formatIntPrice;
    }
    return formatPrice;
};
export const formatPriceCentsKr = function (priceCents) {
    const priceRounded = priceCents / 100;
    return `${priceRounded.toString().replace('.', ',')} kr`;
};
export const formatPrice = (price, minDecimalPlaces = 0, decValue = '') => {
    if (price === undefined)
        return '';
    if (Number.isInteger(price)) {
        return `${price}${decValue}`;
    }
    else {
        const addDecimalPlaces = (price) => {
            const priceRounded = (Math.round(price * 100) / 100).toFixed(2);
            const decimalPointIndex = priceRounded.toString().indexOf('.');
            const realDecimalPlaces = priceRounded.toString().length - decimalPointIndex - 1;
            const decimalPlaces = realDecimalPlaces > minDecimalPlaces ? realDecimalPlaces : minDecimalPlaces;
            return `${priceRounded.toString()}${'0'.repeat(decimalPlaces)}`.substring(0, decimalPointIndex + 1 + decimalPlaces);
        };
        return addDecimalPlaces(price).replace('.', ',');
    }
};
export const formatPriceKr = (price) => {
    if (Number.isInteger(price)) {
        return `${price},00 kr`;
    }
    else {
        const priceRounded = (Math.round(price * 100) / 100).toFixed(2);
        return `${priceRounded.toString().replace('.', ',')} kr`;
    }
};
export const formatPriceZero = (price, hasHyphen = false) => {
    if (hasHyphen) {
        if (Number.isInteger(price)) {
            return `${price},00`;
        }
    }
    const priceRounded = (Math.round(price * 100) / 100).toFixed(2);
    return `${priceRounded.toString().replace('.', ',')}`;
};
export const formatPriceZeroWithTotalPriceAndQuantity = (price, totalPrice = null, quantity = null) => {
    const usedPrice = totalPrice && quantity ? totalPrice / quantity : price;
    const clearedStringPrice = usedPrice.toString().replace(',', '.');
    const clearedNumber = parseFloat(clearedStringPrice);
    const priceRounded = (Math.round(clearedNumber * 100) / 100).toFixed(2);
    return `${priceRounded.toString().replace('.', ',')}`;
};
export const toGuid = (n) => {
    const zeros = '00000000-0000-0000-0000-000000000000';
    const nstr = n + '';
    return zeros.substring(0, zeros.length - nstr.length) + nstr;
};
export const guidToInt = (guid) => {
    const guidSplit = guid.split('-');
    return parseInt(guidSplit[guidSplit.length - 1]);
};
export const isGuid = (s) => {
    const pattern = /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;
    return pattern.test(s);
};
export const generateTraceId = (prefix = 'ERR', length = 12) => {
    const uid = uuid.v1().replace(/-/g, '');
    return `${prefix}-${uid.substring(0, length).toUpperCase()}`;
};
export const copyObject = function (source) {
    if (!source) {
        return source;
    }
    return JSON.parse(JSON.stringify(source));
};
export const getIntegerRatio = function (width, height) {
    const gdc = getGreatestCommonDivisor(width, height);
    return {
        x: Math.round(width / gdc),
        y: Math.round(height / gdc),
    };
};
const prepareSelectedProductsForReceiptLine = function (productSelection) {
    return productSelection.groups
        .map((g) => {
        if (g.selectedProducts.length > 0) {
            return g.selectedProducts.map((sp) => {
                if (typeof sp === 'string') {
                    return {
                        productId: sp,
                        quantity: 0,
                    };
                }
                else {
                    return {
                        productId: sp.productId,
                        quantity: sp.quantity,
                    };
                }
            });
        }
    })
        .filter((g) => g);
};
const filterSelectedProductsFreeQuantity = function (selectedProducts, rootProduct) {
    return selectedProducts
        .map((selectedProductsArray) => {
        return rootProduct.groups
            .map((group) => {
            const prodInGroup = group.products.find((p) => selectedProductsArray.find((sp) => sp.productId === p.id));
            if (prodInGroup && group.options.freeQuantity !== undefined && group.options.freeQuantity > 0) {
                return selectedProductsArray;
            }
            else {
                return undefined;
            }
        })
            .filter((g) => g)[0];
    })
        .filter((s) => s);
};
const findSelectedProductsFromMainProductGroups = function (selectedProducts, rootProduct) {
    return selectedProducts
        .map((selectedProductsArray) => {
        return rootProduct.groups
            .map((group) => {
            const prodInGroup = group.products.find((p) => selectedProductsArray.find((sp) => sp.productId === p.id));
            if (prodInGroup) {
                return Object.assign({}, group);
            }
            else {
                return undefined;
            }
        })
            .filter((g) => g)[0];
    })
        .filter((s) => s);
};
const applyFreeQuantity = function (selectedProducts, foundGroups, productCatalog, receiptLine, forbiddenNames) {
    selectedProducts.forEach((selectedProductsArray, idx) => {
        const optionsCopy = Object.assign({}, foundGroups[idx].options);
        selectedProductsArray.forEach((selectedProduct) => {
            const product = productCatalog.getProduct(selectedProduct.productId);
            const totalQuantity = calculateTotalQuantity(selectedProduct.quantity, optionsCopy);
            const subProductPrice = getSubproductPrice(product, totalQuantity, foundGroups[idx]);
            if (subProductPrice !== '') {
                const oldDesc = receiptLine.description.find((desc) => {
                    return (desc.text.includes(product.name) &&
                        forbiddenNames.find((forbiddenName) => desc.text.includes(forbiddenName)) === undefined);
                });
                const newDescText = transformDescriptionText(oldDesc.text, selectedProduct.quantity, totalQuantity);
                const subProductPriceText = totalQuantity > 0 ? ` ${subProductPrice}` : '';
                const newText = foundGroups[idx].options.freeQuantity !== undefined
                    ? `${newDescText}${subProductPriceText}`
                    : oldDesc.text + ` ${subProductPrice}`;
                oldDesc.text = newText;
            }
            if (optionsCopy.freeQuantity !== undefined && optionsCopy.freeQuantity >= 1) {
                if (totalQuantity >= 0) {
                    optionsCopy.freeQuantity -= selectedProduct.quantity - totalQuantity;
                }
                else {
                    optionsCopy.freeQuantity -= selectedProduct.quantity;
                }
            }
        });
    });
};
export const addAdditionalPricesToReceiptLine = function (productCatalog, productSelection, receiptLine, forbiddenNames = ['fravalgt'], isMenu = false) {
    const rootProduct = productCatalog.getProduct(productSelection.productId);
    if (isMenu) {
        const mainProductSingleGroups = rootProduct.groups.filter((g) => g.appearance === 'single');
        mainProductSingleGroups.map((mainProductSingleGroup) => {
            const mainProduct = mainProductSingleGroup.products.find((p) => p);
            const psMainGroup = productSelection.groups.find((g) => g.groupId === mainProductSingleGroup.id);
            const psMainGroupSelectedProduct = psMainGroup.selectedProducts.find((sp) => sp);
            const preparedSelected = filterSelectedProductsFreeQuantity(prepareSelectedProductsForReceiptLine(psMainGroupSelectedProduct), mainProduct);
            const preparedFoundGroups = findSelectedProductsFromMainProductGroups(preparedSelected, mainProduct);
            applyFreeQuantity(preparedSelected, preparedFoundGroups, productCatalog, receiptLine, forbiddenNames);
        });
    }
    else {
        const selectedProducts = prepareSelectedProductsForReceiptLine(productSelection);
        const foundGroups = findSelectedProductsFromMainProductGroups(selectedProducts, rootProduct);
        applyFreeQuantity(selectedProducts, foundGroups, productCatalog, receiptLine, forbiddenNames);
    }
    return receiptLine;
};
export const updateReceiptLinesWithPantInformation = function (receiptLine, orderLines, index) {
    const includedPrice = orderLines[index].options &&
        orderLines[index].options.foreignIds &&
        orderLines[index].options.foreignIds.onlinePosRules &&
        orderLines[index].options.foreignIds.onlinePosRules.cart &&
        orderLines[index].options.foreignIds.onlinePosRules.cart.find((c) => c.inclPrice);
    if (includedPrice) {
        receiptLine.price -= includedPrice.inclPrice;
        receiptLine.description.push({ text: '+1,50 (pant)' });
    }
};
export const calculateTotalQuantity = function (quantity, options) {
    return quantity !== undefined && options.freeQuantity !== undefined ? quantity - options.freeQuantity : quantity;
};
export const getSubproductPrice = function (product, quantity, group) {
    const price = isNaN(parseInt(product.getPriceInGroup())) ? 0 : product.getPriceInGroup();
    const difference = calculateDifference(price, group);
    if (difference > 0) {
        const newDiff = quantity !== undefined ? quantity * difference : difference;
        if (product.foreignIds.onlinePosRules && product.foreignIds.onlinePosRules.cart) {
            const includedPriceObj = product.foreignIds.onlinePosRules.cart.find((rule) => rule.inclPrice);
            if (includedPriceObj) {
                return ('(+' + formatPriceZeroWithTotalPriceAndQuantity(newDiff) + ')\n' + getIncludedPriceString(includedPriceObj));
            }
        }
        return '(+' + formatPriceZeroWithTotalPriceAndQuantity(newDiff) + ')';
    }
    else if (product.foreignIds.onlinePosRules && product.foreignIds.onlinePosRules.cart) {
        const includedPriceObj = product.foreignIds.onlinePosRules.cart.find((rule) => rule.inclPrice);
        if (includedPriceObj) {
            return `\n${getIncludedPriceString(includedPriceObj)}`;
        }
    }
    return '';
};
export const getIncludedPriceString = function (includedPriceObj) {
    return `+${formatPriceZeroWithTotalPriceAndQuantity(includedPriceObj.inclPrice)} (${includedPriceObj.name})`;
};
export const calculateDifference = function (price, group) {
    const defaultSelectedProduct = group.products.find((product) => product.id === group.options.defaultSelected);
    if (defaultSelectedProduct) {
        return price - defaultSelectedProduct.getPriceInGroup();
    }
    else {
        return price;
    }
};
export const transformDescriptionText = function (descriptionText, quantity, totalQuantity) {
    if (quantity !== totalQuantity && descriptionText.includes('x')) {
        const descriptionArray = descriptionText.split(' ');
        const productName = descriptionArray.length === 4
            ? descriptionArray[descriptionArray.length - 2]
            : descriptionArray[descriptionArray.length - 1];
        const freePart = `${productName} (inkluderet)`;
        const paidPart = totalQuantity > 0 ? `\n${totalQuantity} x ${productName}` : '';
        return `${freePart}${paidPart}`;
    }
    else if (quantity !== totalQuantity && !descriptionText.includes('x')) {
        return `${descriptionText} (inkluderet)`;
    }
    else {
        const descriptionTextArray = descriptionText.split(' ');
        descriptionTextArray.pop();
        return `${descriptionTextArray.join(' ')}`;
    }
};
export const createSeoOptimizedProductName = (name) => {
    if (typeof name !== 'string') {
        return name;
    }
    const trimmedName = name.trim();
    const charactersToReplace = [
        { key: /Æ/g, value: 'AE' },
        { key: /Ø/g, value: 'OE' },
        { key: /Å/g, value: 'AA' },
        { key: /æ/g, value: 'ae' },
        { key: /ø/g, value: 'oe' },
        { key: /å/g, value: 'aa' },
        { key: /\s+/g, value: '-' },
    ];
    const specialCharacterMappedName = charactersToReplace.reduce((mappedName, regex) => {
        return mappedName.replace(regex.key, regex.value);
    }, trimmedName);
    return specialCharacterMappedName.toLowerCase();
};
export const msToMinutes = (ms) => {
    return Math.floor(ms / 60000);
};
export const msToHours = (ms) => {
    return Math.floor(ms / 3600000);
};
export const msToDays = (ms) => {
    return Math.floor(ms / 86400000);
};
const getProductName = (allProducts, product, productsById) => {
    if (product.name) {
        return product.name;
    }
    const foundProduct = productsById
        ? productsById.get(product.id_ref) || {}
        : allProducts.find((e) => e.id === product.id_ref) || {};
    return foundProduct.name;
};
export const sortByProductName = (subProductPositions, allProducts, productsById) => (left, right) => {
    const [leftName, rightName] = [
        getProductName(allProducts, left, productsById),
        getProductName(allProducts, right, productsById),
    ];
    if (!subProductPositions[leftName]) {
        return 1;
    }
    if (!subProductPositions[rightName]) {
        return -1;
    }
    return subProductPositions[leftName] - subProductPositions[rightName];
};
export const reorderGroupProducts = (allProducts, productsById) => (group) => {
    const subProductPositionsTemp = get(group, 'options.subProductPositions') || {};
    const subProductPositions = Array.isArray(subProductPositionsTemp)
        ? Object.assign({}, ...subProductPositionsTemp)
        : subProductPositionsTemp;
    const products = group.products.slice();
    if (Object.keys(subProductPositions).length > 0) {
        products.sort(sortByProductName(subProductPositions, allProducts, productsById));
    }
    return Object.assign(Object.assign({}, group), { products });
};
export const getPersonId = (externalIdpId, provider) => {
    switch (provider) {
        case 'Gigya':
            return externalIdpId;
        case 'Auth0': {
            const [auth0, id] = externalIdpId.split('|');
            if (id === undefined || auth0 !== 'auth0') {
                throw Error('Sub is not in correct format!');
            }
            return id;
        }
        case 'SprintingIdp':
            return externalIdpId;
        default:
            throw new Error('provider not supported');
    }
};
export const isSpecificProductGroupType = (group, groupType) => {
    return group && group.options && group.options.groupType === groupType;
};
export const replaceTenantIdForBm = (object, tenantId) => {
    const newObject = copyObject(object);
    newObject.tenantId = tenantId;
    return newObject;
};
export const isDiscountApplicableByChannel = (discount, channel) => {
    var _a, _b, _c, _d;
    return !channel || !((_b = (_a = discount === null || discount === void 0 ? void 0 : discount.options) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.length) || ((_d = (_c = discount === null || discount === void 0 ? void 0 : discount.options) === null || _c === void 0 ? void 0 : _c.channels) === null || _d === void 0 ? void 0 : _d.includes(channel));
};
export const isDiscountApplicableByCustomerType = (discount, customerType) => {
    var _a, _b, _c, _d;
    return (!customerType ||
        !((_b = (_a = discount === null || discount === void 0 ? void 0 : discount.options) === null || _a === void 0 ? void 0 : _a.customerTypes) === null || _b === void 0 ? void 0 : _b.length) ||
        ((_d = (_c = discount === null || discount === void 0 ? void 0 : discount.options) === null || _c === void 0 ? void 0 : _c.customerTypes) === null || _d === void 0 ? void 0 : _d.includes(customerType)));
};
export const isDiscountApplicableByDeliveryMethod = (discount, deliveryMethod) => {
    var _a, _b, _c, _d;
    return (!Number.isInteger(deliveryMethod) ||
        !((_b = (_a = discount === null || discount === void 0 ? void 0 : discount.options) === null || _a === void 0 ? void 0 : _a.deliveryMethods) === null || _b === void 0 ? void 0 : _b.length) ||
        ((_d = (_c = discount === null || discount === void 0 ? void 0 : discount.options) === null || _c === void 0 ? void 0 : _c.deliveryMethods) === null || _d === void 0 ? void 0 : _d.includes(+deliveryMethod)));
};
export const filterProductDiscounts = (product, additionalCriteria) => {
    var _a;
    if (!additionalCriteria.channel &&
        !Number.isInteger(additionalCriteria.deliveryMethod) &&
        !additionalCriteria.customerType) {
        return product.discount;
    }
    if (isDiscountApplicableByChannel(product.discount, additionalCriteria.channel) &&
        isDiscountApplicableByDeliveryMethod(product.discount, additionalCriteria.deliveryMethod) &&
        isDiscountApplicableByCustomerType(product.discount, additionalCriteria.customerType) &&
        product.discount.discountType !== 'globalDiscountWithMax') {
        return product.discount;
    }
    if ((_a = product.applicableDiscounts) === null || _a === void 0 ? void 0 : _a.length) {
        const nextApplicableDiscount = product.applicableDiscounts.find((applicableDiscount) => {
            var _a, _b, _c, _d, _e, _f;
            if (!((_b = (_a = applicableDiscount.options) === null || _a === void 0 ? void 0 : _a.channels) === null || _b === void 0 ? void 0 : _b.length) &&
                !((_d = (_c = applicableDiscount.options) === null || _c === void 0 ? void 0 : _c.deliveryMethods) === null || _d === void 0 ? void 0 : _d.length) &&
                !((_f = (_e = applicableDiscount.options) === null || _e === void 0 ? void 0 : _e.customerTypes) === null || _f === void 0 ? void 0 : _f.length)) {
                return true;
            }
            return (isDiscountApplicableByChannel(applicableDiscount, additionalCriteria.channel) &&
                isDiscountApplicableByDeliveryMethod(applicableDiscount, additionalCriteria.deliveryMethod) &&
                isDiscountApplicableByCustomerType(product.discount, additionalCriteria.customerType) &&
                applicableDiscount.discountType !== 'globalDiscountWithMax');
        });
        if (nextApplicableDiscount)
            return nextApplicableDiscount;
    }
    return null;
};
export const throwIfTimeout = (promise, ms, customMessage) => {
    const timeout = new Promise((_, reject) => {
        const id = setTimeout(() => {
            clearTimeout(id);
            reject(new Error(customMessage ? customMessage : 'Request timed out'));
        }, ms);
    });
    return Promise.race([promise, timeout]);
};
export const alphaCharacters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
export { getProductPrice, } from '../orders/PriceCalculationLegacy';
export const collectSelectionsWithDiscount = (selection, parentKey = '') => {
    const items = [];
    const baseKey = parentKey
        ? `${parentKey}-${selection.productSelectionId || selection.id}`
        : selection.productSelectionId || selection.id;
    if (selection.isTimeLimittedDiscount && selection.discountExpiresAt) {
        items.push({
            id: baseKey,
            discountExpiresAt: selection.discountExpiresAt,
        });
    }
    if (selection.groups) {
        selection.groups.forEach((group) => {
            const groupKey = `${baseKey}-${group.id}`;
            if (group.isTimeLimittedDiscount && group.discountExpiresAt) {
                items.push({
                    id: groupKey,
                    discountExpiresAt: group.discountExpiresAt,
                });
            }
            if (group.selectedProducts) {
                group.selectedProducts.forEach((sp) => {
                    items.push(...collectSelectionsWithDiscount(sp, groupKey));
                });
            }
        });
    }
    return items;
};
export const collectSelectionsWithDiscountOptions = (selection) => {
    const items = [];
    const baseKey = selection.productSelectionId || selection.id;
    if (selection.discountOptions) {
        items.push({
            id: baseKey,
            discountOptions: selection.discountOptions,
            productId: selection.productId,
            quantity: selection.quantity,
        });
    }
    if (selection.groups) {
        selection.groups.forEach((group) => {
            if (group.selectedProducts) {
                group.selectedProducts.forEach((sp) => {
                    items.push(...collectSelectionsWithDiscountOptions(sp));
                });
            }
        });
    }
    return items;
};
export const collectOrderLinesWithDiscountOptions = (orderLine) => {
    var _a, _b;
    const items = [];
    if ((_a = orderLine.discount) === null || _a === void 0 ? void 0 : _a.options) {
        const discountApplied = orderLine.totalPriceBeforeAccum
            ? orderLine.totalPriceBeforeAccum - orderLine.totalPriceAccum > 0
            : orderLine.totalPriceAccum === 0;
        if (discountApplied) {
            items.push({
                discountOptions: Object.assign(Object.assign({}, (_b = orderLine.discount) === null || _b === void 0 ? void 0 : _b.options), { discountId: orderLine.discount.discountId, voucherPattern: orderLine.discount.voucherPattern }),
                productId: orderLine.productId,
                quantity: orderLine.quantity,
            });
        }
    }
    if (orderLine.subLines) {
        orderLine.subLines.forEach((subLine) => {
            if (subLine.selectedOptions) {
                subLine.selectedOptions.forEach((so) => {
                    items.push(...collectOrderLinesWithDiscountOptions(so));
                });
            }
            if (subLine.subLines) {
                subLine.subLines.forEach((sl) => {
                    items.push(...collectOrderLinesWithDiscountOptions(sl));
                });
            }
        });
    }
    return items;
};
export const removeDuplicatesFromArray = (arr) => {
    return Array.from(new Set(arr));
};
